// Resolves the URL hash to one of a tab set's ids, or the fallback.
//
// Exact match on the hash, deliberately — NOT `hash.includes(id)`, which
// several pages grew independently and which is wrong two ways:
//
//   - a shorter id that prefixes a longer one wins when it is scanned first.
//     `activation_rate` prefixes `activation_rate_at_select_locations`, so
//     #activation_rate_at_select_locations resolved to the Activation rate
//     tab. Ordering the scan longest-first patches that one case but leaves
//     the class of bug in place, so it isn't the fix.
//   - any hash merely *containing* an id matches, so #foo_activation_rate_bar
//     selects a tab.
//
// Every writer sets a bare id (`history.replace({ hash: tab })`), so there is
// nothing that needs substring matching. This mirrors what InnerTabs and
// PromoCodeReport already do.
export const tabFromHash = <T extends string>(
  hash: string,
  tabs: readonly T[],
  fallback: T
): T => {
  const id = hash.replace(/^#/, '')
  return (tabs as readonly string[]).includes(id) ? (id as T) : fallback
}
